import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import type { THygieneTasksDrilldown } from '@/react-query/insights/types';

import { PatientName } from '../../components/PatientName';

// Reusable component for task status icon
const HygieneTaskStatusIcon = ({
  value,
}: {
  value: string | null | undefined;
}) => {
  if (value === 'COMPLETED') {
    return (
      <FontAwesomeIcon
        icon={faCheckCircle}
        className="vai-ml-1 vai-h-4 vai-w-4 vai-text-green-500"
      />
    );
  }
  if (value === 'SUGGESTED') {
    return (
      <FontAwesomeIcon
        icon={faCircle}
        className="vai-ml-1 vai-h-4 vai-w-4 vai-text-red-500"
      />
    );
  }
  return (
    <div className="vai-flex vai-items-center vai-justify-center vai-w-6 vai-h-6">
      <span className="vai-text-gray-400 vai-text-2xl">-</span>
    </div>
  );
};

export const hygieneProviderTableColumnsBase: ColumnDef<
  THygieneTasksDrilldown,
  unknown
>[] = [
  {
    accessorKey: 'apptDate',
    header: 'Appointment Date',
    cell: ({ row }) => {
      // Create date in local timezone by adding time component
      const localDate = new Date(row.original.apptDate + 'T00:00:00');
      return <div>{format(localDate, 'MM/dd/yyyy')}</div>;
    },
  },
  {
    accessorKey: 'patientName',
    header: 'Patient Name',
    cell: ({ row }) => {
      return <PatientName patientName={row.original.patientName} />;
    },
  },
];

export const hygieneProviderTableColumnsTypes: ColumnDef<
  THygieneTasksDrilldown,
  unknown
>[] = [
  {
    accessorKey: 'bitewings',
    header: 'Bitewings',
    cell: ({ row }) => {
      return <HygieneTaskStatusIcon value={row.original.bitewings} />;
    },
  },
  {
    accessorKey: 'perioMaintenance',
    header: 'Perio Maintenance',
    cell: ({ row }) => {
      return <HygieneTaskStatusIcon value={row.original.perioMaintenance} />;
    },
  },
  {
    accessorKey: 'prophy',
    header: 'Prophy',
    cell: ({ row }) => {
      return <HygieneTaskStatusIcon value={row.original.prophy} />;
    },
  },
  {
    accessorKey: 'perioChart',
    header: 'Perio Chart',
    cell: ({ row }) => {
      return <HygieneTaskStatusIcon value={row.original.perioChart} />;
    },
  },
];
